import { useMemo } from 'react';
import { MemberTabList, MemberTabListRBDM } from '@components/members';
import { useGetRxDb } from '@hooks/getRxdbData';
import { ProfileData } from '@services/hooks/profile';
import { ITabList } from '@components/common/navigator-tab';

export const useRoleBasedMemberTabList = (): ITabList[] => {
	const { result: profile } = useGetRxDb<ProfileData>('profile');

	const roleBasedTabList = useMemo(() => {
		// If profile is not loaded yet, return empty array to prevent initial render
		if (!profile || profile.length === 0) {
			return [];
		}

		const userRole = profile[0]?.usertype_c;

		// For RBDM users, show only the "All" tab
		if (userRole === 'RBDM') {
			return MemberTabListRBDM;
		}

		// For all other users, show all tabs
		return MemberTabList;
	}, [profile]);

	return roleBasedTabList;
};
